<app-alert
  class="bg-navy-90"
  [alertType]="'success'"
  [displayCloseBtn]="displayCloseBtn"
  (closeClick)="closeClick.emit()"
>
  <div class="flex flex-row items-center gap-3">
    <app-circle-loader class="h-5 w-5" [appearance]="'light'"></app-circle-loader>
    <span>{{ text | translate }}</span>
  </div>
</app-alert>
